import { useLocalizationContext } from '@im/react-localization';
import { useOktaAuth } from '@okta/okta-react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useDeleteRedundantSession } from './useAutoSignIn';

export function RedirectToIdp() {
  const oktaContext = useOktaAuth();
  const { oktaAuth } = oktaContext;
  const location = useLocation();
  const { locale } = useLocalizationContext();
  const historyState = location.state as { from: Location };
  const deleteRedundantSession = useDeleteRedundantSession();
  let originalUri = '/';
  if (historyState) {
    const { pathname, search } = historyState.from;
    originalUri = pathname + search;
  }

  useEffect(() => {
    deleteRedundantSession().then(() => {
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect({
        extraParams: {
          locale: locale,
        },
      });
    });
  }, [deleteRedundantSession, locale, oktaAuth, originalUri]);

  return <></>;
}
